import { fromJS } from 'immutable';

import { benchmarkScore } from './types';

export * from './actions';

const initialState = fromJS({
  businessScore: {
    score: '',
    network: { loading: true, error: false },
  },
});

const postBenchmarkDataRequest = (state) =>
  state.setIn(['businessScore', 'network', 'loading'], true);

const postBenchmarkDataSuccess = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['businessScore', 'network', 'loading'], false)
      .setIn(['businessScore', 'network', 'error'], false)
      .setIn(['businessScore', 'score'], action.businessScore),
  );

const postBenchmarkDataError = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['businessScore', 'network', 'loading'], false)
      .setIn(['businessScore', 'network', 'error'], action.error)
      .setIn(['businessScore', 'score'], 0),
  );

const entitiesBatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case benchmarkScore.request:
      return postBenchmarkDataRequest(state, action);
    case benchmarkScore.success:
      return postBenchmarkDataSuccess(state, action);
    case benchmarkScore.failure:
      return postBenchmarkDataError(state, action);

    default:
      return state;
  }
};

export default entitiesBatchReducer;
